import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center mt-3" }
const _hoisted_2 = {
  key: 0,
  class: "inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
  role: "status"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]" }, "Loading...", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NewModal, {
      title: "Contrato firmado",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}